import { useAuth } from "../../Providers/AuthProvider";
import { FaCheck, FaXmark } from "react-icons/fa6";
import { toast } from "react-toastify";
import useCheckUserRole from "../BasketPage/Hooks/useCheckUserRole.ts";
import { UserRole } from "../../Data/UserRolesEnum.ts";

import "./CheckBoxList.css";

const CheckBoxList = ({ title, userRoles, selectedRoles, setSelectedRoles }) => {
    const { authState } = useAuth()
    const { isUserHasAccess } = useCheckUserRole()

    const handleSelectOption = (roleId) => {
        if (roleId == 1) {
            if ((authState.user.isOperator && !authState.user.upR_FINANSE) || (!authState.user.isOperator && !isUserHasAccess(UserRole.Admin))) {
                toast.warning('Nie masz uprawnień do wykonania tej akcji!')
                return
            }
        }

        if (selectedRoles.includes(roleId)) {
            setSelectedRoles(selectedRoles.filter((optionId) => optionId !== roleId));
        } else {
            setSelectedRoles([...selectedRoles, roleId]);
        }
    };

    return (
        <div className="container">
            <h3 className="checkbox-list-title">{title}</h3>
            <div className="roles-container">
                {userRoles.map((role) => (
                    <div key={role.roleId} className="role-item">
                        <div className="role-info">
                            <span className="role-name">{role.roleName}</span>
                            <span className="role-description">{role.roleDescription}</span>
                        </div>
                        <div className={`custom-switch ${selectedRoles.includes(role.roleId) ? "active" : ""}`} onClick={() => handleSelectOption(role.roleId)}>
                            <div className="custom-switch-circle">
                                {selectedRoles.includes(role.roleId) ? <FaCheck className='primary-accent-color-text' /> : <FaXmark />}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CheckBoxList;
